export const OfficeApplianceGeneralInfo = ({
  applianceDetails,
  navigateToOffice,
}) => {
  //#region Data Display

  const display1stRow = [
    {
      label: "Retail Store Address:",
      value: applianceDetails?.retailStoreAddress,
    },
    { label: "Type:", value: applianceDetails?.officeApplianceType },
    {
      label: "Brand:",
      value: applianceDetails?.officeApplianceBrand,
    },
    {
      label: "Purchase Date:",
      value:
        applianceDetails?.purchaseDate &&
        new Date(applianceDetails?.purchaseDate).toLocaleDateString(),
    },
    { label: "Purchase Order:", value: applianceDetails?.purchaseOrder },
    { label: "Quantity Ordered:", value: applianceDetails?.quantityOrdered },
  ];

  const display2ndRow = [
    {
      label: "Item Description:",
      value: applianceDetails?.itemDescription,
    },
    { label: "Model Number:", value: applianceDetails?.modelNumber },
    {
      label: "Part Number:",
      value: applianceDetails?.partNumber,
    },
    {
      label: "Item Price:",
      value: `$${applianceDetails?.itemPrice}`,
    },
    {
      label: "Status:",
      value: applianceDetails?.isActive ? "Active" : "Inactive",
    },
  ];
  //#endregion

  return (
    <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
      <div className="text-quinary font-bold font-sans py-2 px-6">
        Office Appliance Details
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 mx-4 expandedLabel fontExpand">
              Retail Store Number:
            </label>
            <label
              className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
              onClick={() => {
                navigateToOffice();
              }}
            >
              {applianceDetails.retailStoreNumber}
            </label>
          </div>
          {display1stRow.map((item, i) =>
            item ? (
              <DisplayRow key={i} label={item.label} value={item.value} />
            ) : null
          )}
        </div>
        <div className="p-2 divide-y">
          {display2ndRow.map((item, i) =>
            item ? (
              <DisplayRow key={i} label={item.label} value={item.value} />
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

const DisplayRow = ({ label, value }) => (
  <div className="grid grid-cols-3 p-2">
    <label className="fontExpand expandedLabel mx-4">{label}</label>
    <div className="col-span-2 expandedData fontExpand">
      <label>{value}</label>
    </div>
  </div>
);
